import React from 'react';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

const ROUNDED: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  sm: 'aspectly:rounded-sm',
  md: 'aspectly:rounded-md',
  lg: 'aspectly:rounded-lg',
  xl: 'aspectly:rounded-xl',
  '2xl': 'aspectly:rounded-2xl',
  full: 'aspectly:rounded-full',
};

export function Skeleton({ rounded = 'xl', className = '', ...props }: SkeletonProps) {
  const roundedClass = ROUNDED[rounded];

  return (
    <div
      className={`aspectly:bg-surface-container-high aspectly:animate-pulse ${roundedClass} ${className}`}
      {...props}
    />
  );
}
